import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { emailRegex } from '../../../utils/constants';
import { loadingWrapper } from '../../../utils/loadingWrapper';
import { toast } from 'react-toastify';
import { setBody, setOnCancel, setOnConfirm, setShow, setTitle } from '../../../slice/confirmModalSlice';
import { setSelectedUser, setShowEditUserModal } from '../../../slice/editUserSlice';
import useUser from '../../../hooks/useUser';
import CustomSwitch from '../../custom-switch/CustomSwitch';
import useTag from '../../../hooks/useTag';
import PillLabel from '../../pill-label/PillLabel';
import { privileges } from '../../../config/role';
import { setShowApplicationLogsModal } from '../../../slice/showModalSlice';

const EditUser = ({ onSuccess }) => {
  const dispatch = useDispatch();

  const show = useSelector((s) => s.editUser.showEditUserModal);
  const selectedUser = useSelector((s) => s.editUser.selectedUser);
  const userRole = useSelector((s) => s.user.role);

  const authorized = privileges.editingUsers.includes(userRole);
  const authorizedApplicationLogs = privileges.applicationLogs.includes(userRole);

  const { getUserTags, tagLoading } = useTag();

  const {
    editUser,
    deleteUser,
    resetPassword,
    changeUserStatus,
    userLoading,
  } = useUser();


  const [userTagList, setUserTagList] = useState([]);

  const [companyList] = useState([
    { id: 1, name: 'Nordcom' },
    { id: 2, name: 'FNMA' },
  ]);

  const [isEditEnabled, setEditEnabled] = useState(false);

  const [userData, setUserData] = useState({
    id: undefined,
    enabled: true,
    username: '',
    firstname: '',
    lastname: '',
    email: '',
    tags: [],
    userTagIds: [],
    userTagIdsWithTime: [],
    roleIds: [],
    companyName: '',
    extId: '',
    using2FA: true,
    twoFactorType: 'MAIL_OTP',
    accessProfileId: 0,
    customAttributes: {
      additionalProp1: {},
      additionalProp2: {},
      additionalProp3: {},
    },
    mobileUuidState: 'NEVER_SET',
    companyNotificationsEnabled: true,
    invitationLimit: 0,
    canTogglePassageMode: true,
    enableDoor: false,
    role:"",
  });
  const roleList = useSelector((state) => state.generalSetting.roleList);

  const inputValidator = {
    firstname: (userData.firstname || '').trim().length > 0,
    lastname: (userData.lastname || '').trim().length > 0,
    companyName: (userData.companyName || '').trim().length > 0,
    email: emailRegex.test(userData.email || ''),
    role: userData.role !== "",
  };

  const isConfirmDisabled = () =>
    !(
      inputValidator.firstname &&
      inputValidator.lastname &&
      inputValidator.email &&
      inputValidator.companyName &&
      inputValidator.role
    );

  useEffect(() => {
    if (selectedUser == null) return;
    const body = JSON.parse(JSON.stringify(selectedUser));
    const rawTags = Array.isArray(body.tags) ? body.tags : [];
    body.tags = rawTags;
    body.userTagIds = rawTags.map(t => Number(t.id));
    body.userTagIdsWithTime = body.userTagIdsWithTime ?? [];
    body.enabled = body.enabled ?? true;
    //if (!body.username && body.email) body.username = body.email;
    setUserData(body);
    setEditEnabled(false);
  }, [selectedUser]);

  useEffect(() => {
    if (show) {
      getTags(false);
    }
  }, [show]);

  const getTags = (includeUserTags = false) => {
    getUserTags(
      (data) => {
        setUserTagList(data.content || data.items || data || []);
      },
      (error) => {
        console.log('errore nel ricevere i tag utente', error);
      },
      includeUserTags
    );
  };

  const closeEdit = () => {
    dispatch(setShowEditUserModal());
    setEditEnabled(false);
    dispatch(setSelectedUser(null));
    setUserData({
      id: undefined,
      enabled: true,
      username: '',
      firstname: '',
      lastname: '',
      email: '',
      tags: [],
      userTagIds: [],
      userTagIdsWithTime: [],
      roleIds: [],
      companyName: '',
      extId: '',
      using2FA: true,
      twoFactorType: 'MAIL_OTP',
      accessProfileId: 0,
      customAttributes: {
        additionalProp1: {},
        additionalProp2: {},
        additionalProp3: {},
      },
      mobileUuidState: 'NEVER_SET',
      companyNotificationsEnabled: true,
      invitationLimit: 0,
      canTogglePassageMode: true,
      enableDoor: false,
      role:"",
    });
  };

  const addTagToUser = (tagId) => {
    if (tagId === '') return;
    const id = Number(tagId);
    setUserData(prev => {
      const hasAlready = (prev.userTagIds || []).some(tid => Number(tid) === id);
      if (hasAlready) return prev;
      const tagObj = (userTagList || []).find(t => Number(t.id) === id);
      return {
        ...prev,
        userTagIds: [...(prev.userTagIds || []), id],
        tags: tagObj ? [ ...(prev.tags || []), tagObj ] : (prev.tags || []),
      };
    });
  };

  const removeTagFromUser = (id) => {
    setUserData(prev => ({
      ...prev,
      userTagIds: (prev.userTagIds || []).filter(tid => Number(tid) !== Number(id)),
      tags: (prev.tags || []).filter(t => Number(t.id) !== Number(id)),
    }));
  };

  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === 'email') {
      setUserData((prev) => ({ ...prev, email: value, username: value }));
    } else if (name === 'roleIds') {
      const guest = (userData.roleIds || []).filter((x) => x === 5);
      if (value) {
        const roleId = parseInt(value, 10);
        setUserData((prev) => ({ ...prev, roleIds: [...guest, roleId] }));
      } else {
        setUserData((prev) => ({ ...prev, roleIds: guest }));
      }
    } else {
      setUserData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const toggleGuestRole = () => {
    if(userData.enableDoor){
            setUserData({...userData, enableDoor:false, role:userData.role === "ACCESS_OPERATOR" ?"":userData.role});
        }else{
            setUserData({...userData, enableDoor:true,role: userData.role === "" ?"ACCESS_OPERATOR":userData.role});
        }
  };


  const editHandler = () => setEditEnabled((v) => !v);

  const applicationLogsHandler = () =>{
    dispatch(setShowApplicationLogsModal());
  }

  const cancelEdit = () => {
    if (selectedUser == null) return;
    const body = JSON.parse(JSON.stringify(selectedUser));
    const rawTags = Array.isArray(body.tags) ? body.tags : [];
    body.tags = rawTags;
    body.userTagIds = rawTags.map(t => Number(t.id));
    body.userTagIdsWithTime = body.userTagIdsWithTime ?? [];
    body.enabled = body.enabled ?? true;
    //if (!body.username && body.email) body.username = body.email;
    setUserData(body);
    setEditEnabled(false);
  };

  const openConfirm = () => dispatch(setShow());

  const confirmEdit = () => {
    dispatch(setTitle('Conferma Modifica'));
    dispatch(setBody(`Confermi la modifica dell'utente ${userData?.username || ''}?`));
    dispatch(setOnConfirm(() => sendChanges()));
    dispatch(setOnCancel(() => openConfirm()));
    openConfirm();
  };

  const confirmDelete = () => {
    dispatch(setTitle('Conferma Cancellazione'));
    dispatch(setBody(`Confermi la cancellazione dell'utente ${userData?.username || ''}? Questa azione non è reversibile. Se serve solo per disabilitare l'utente, usa il tasto disabilita.`));
    dispatch(setOnConfirm(() => sendDelete()));
    dispatch(setOnCancel(() => openConfirm()));
    openConfirm();
  };

  const confirmResetPassword = () => {
    dispatch(setTitle('Reset Password'));
    dispatch(setBody(`Confermare reset password per l'utente ${userData?.username || ''}?`));
    dispatch(setOnConfirm(() => sendResetPassword()));
    dispatch(setOnCancel(() => openConfirm()));
    openConfirm();
  };

  const confirmToggleStatus = () => {
    const next = userData.enabled ? 'disable' : 'enable';
    dispatch(setTitle(userData.enabled ? 'Disabilita utente' : 'Abilita utente'));
    dispatch(
      setBody(
        `Confermi di ${userData.enabled ? 'disabilitare' : 'abilitare'} ${userData?.username || ''}?`
      )
    );
    dispatch(setOnConfirm(() => sendToggleStatus(next)));
    dispatch(setOnCancel(() => openConfirm()));
    openConfirm();
  };

  const sendChanges = () => {
    if (!userData.id) return;
    const { tags, ...rest } = userData;
    const payload = { ...rest, username: userData.email };
    editUser(
      userData.id,
      payload,
      () => {
        toast.success('Utente modificato con successo');
        onSuccess?.();
        closeEdit();
      },
      () => toast.error('Errore nella modifica dell’utente')
    );
    openConfirm();
  };

  const sendDelete = () => {
    if (!userData.id) return;
    deleteUser(
      userData.id,
      () => {
        toast.success('Utente eliminato con successo');
        onSuccess?.();
        closeEdit();
      },
      () => toast.error('Errore nella cancellazione dell’utente')
    );
    openConfirm();
  };

  const sendToggleStatus = (change) => {
    if (!userData.id) return;
    changeUserStatus(
      userData.id,
      change,
      () => {
        toast.success(`Utente ${change === 'enable' ? 'abilitato' : 'disabilitato'} con successo`);
        setUserData((prev) => ({ ...prev, enabled: change === 'enable' }));
        onSuccess?.();
      },
      () => toast.error('Errore nella modifica dello stato utente')
    );
    openConfirm();
  };

  const sendResetPassword = () => {
    if (!userData.id) return;
    resetPassword(
      userData.id,
      () => toast.success('Password resettata'),
      () => toast.error('Errore nell’invio del reset password')
    );
    openConfirm();
  };

  const visibleTags = (userData.tags || []).filter(tag =>
    userTagList.some(t => Number(t.id) === Number(tag.id))
  );

  return (
    <Modal
      show={show}
      size="md"
      backdrop={isEditEnabled ? "static" : true}
      onHide={userLoading ? null : closeEdit}
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-primary-custom">
          {isEditEnabled ? "Modifica Utente" : "Info Utente"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="d-flex flex-column gap-3">
          <fieldset className="detail-fieldset flex-column gap-2 align-items-center w-100">
            <legend className="detail-legend text-primary-custom">
              Dati Anagrafici
            </legend>

            <div className="d-flex gap-2 w-100">
              <div className="d-flex flex-column w-100">
                <p className="m-0">Nome</p>
                <input
                  className={`form-control ${
                    inputValidator.firstname ? "" : "is-invalid"
                  }`}
                  type="text"
                  name="firstname"
                  required
                  disabled={!isEditEnabled}
                  value={userData.firstname}
                  onChange={inputHandler}
                />
              </div>

              <div className="d-flex flex-column w-100">
                <p className="m-0">Cognome</p>
                <input
                  className={`form-control ${
                    inputValidator.lastname ? "" : "is-invalid"
                  }`}
                  type="text"
                  name="lastname"
                  required
                  disabled={!isEditEnabled}
                  value={userData.lastname}
                  onChange={inputHandler}
                />
              </div>
            </div>

            <div className="d-flex w-100">
              <div className="d-flex flex-column w-100">
                <p className="m-0">Email</p>
                <input
                  className={`form-control ${
                    inputValidator.email ? "" : "is-invalid"
                  }`}
                  type="text"
                  name="email"
                  required
                  disabled={!isEditEnabled}
                  value={userData.email}
                  onChange={inputHandler}
                />
              </div>
            </div>

            <div className="d-flex w-100">
              <div className="d-flex flex-column w-100">
                <p className="m-0">Compagnia</p>
                <select
                  className={`form-control ${
                    inputValidator.companyName ? "" : "is-invalid"
                  }`}
                  name="companyName"
                  value={userData.companyName || ""}
                  onChange={inputHandler}
                  disabled={!isEditEnabled}
                >
                  <option value={""}>Seleziona una compagnia</option>
                  {companyList.map((company) => (
                    <option key={company.id} value={company.name}>
                      {company.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </fieldset>

          <fieldset className="detail-fieldset flex-column gap-2 align-items-center w-100">
            <legend className="detail-legend text-primary-custom">Tag</legend>

            <div className="d-flex gap-2 w-100 overflow-x-auto pb-4 pt-2">
              {visibleTags.length > 0 ? (
                visibleTags.map((tag) => (
                  <PillLabel
                    key={tag.id}
                    name={tag.name}
                    color={tag.color}
                    onClick={
                      isEditEnabled
                        ? () => removeTagFromUser(tag.id)
                        : undefined
                    }
                  />
                ))
              ) : (
                <p className="text-secondary m-0 text-center w-100">
                  Nessun tag associato
                </p>
              )}
            </div>

            <div className="d-flex w-100">
              <div className="d-flex flex-column w-100">
                <select
                  className="form-select"
                  value={""}
                  onChange={(e) => addTagToUser(e.target.value)}
                  disabled={!isEditEnabled || tagLoading}
                >
                  <option value={""}>Seleziona un tag</option>
                  {userTagList.map((tag) => (
                    <option key={tag.id} value={tag.id}>
                      {tag.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </fieldset>

          <fieldset className="detail-fieldset flex-column gap-2 align-items-center w-100">
            <legend className="detail-legend text-primary-custom">
              Permessi
            </legend>

            <div className="d-flex gap-2 w-100">
              <div className="d-flex w-100 gap-4 align-items-center">
                <div className="d-flex flex-column justify-content-center">
                  <p className="m-0">Porte</p>
                  <CustomSwitch
                    id={"roleGuest"}
                    disabled={!isEditEnabled}
                    isChecked={userData.enableDoor}
                    onChange={toggleGuestRole}
                  />
                </div>

                <div className="d-flex flex-column w-100">
                  <p className="m-0">Autorizzazioni speciali</p>
                  <select
                    className="form-select"
                    name="role"
                    value={userData.role}
                    onChange={inputHandler}
                    disabled={!isEditEnabled}
                  >
                    <option value={""}>Nessuna Autorizzazione</option>
                    <option hidden value={"SUPER_ADMIN"}>Super Admin</option>
                    {roleList.map((role, index) => {
                      return (
                        <option key={`role-key-${index}`} value={role.code}>
                          {role.value}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
          </fieldset>

          {authorized && <fieldset className="detail-fieldset gap-2 justify-content-center">
            <legend className="detail-legend text-primary-custom">
              Azioni
            </legend>

            {!isEditEnabled ? (
              <>
                <Button variant="danger" onClick={editHandler}>
                  Modifica
                </Button>

                <Button
                  variant="secondary"
                  disabled={userLoading}
                  onClick={confirmResetPassword}
                >
                  {loadingWrapper(userLoading, <>Reset Password</>)}
                </Button>

                <Button
                  variant={userData.enabled ? "warning" : "success"}
                  disabled={userLoading}
                  onClick={confirmToggleStatus}
                >
                  {loadingWrapper(
                    userLoading,
                    <>{userData.enabled ? "Disabilita" : "Abilita"}</>
                  )}
                </Button>

                <Button
                  variant="danger"
                  disabled={userLoading}
                  onClick={confirmDelete}
                >
                  {loadingWrapper(userLoading, <>Elimina</>)}
                </Button>
                {authorizedApplicationLogs && <Button variant="secondary" onClick={applicationLogsHandler}>Logs Applicazione</Button>}
              </>
            ) : (
              <>
                <Button
                  variant="secondary"
                  onClick={cancelEdit}
                  disabled={userLoading}
                >
                  Annulla
                </Button>
                <Button
                  className="btn-green"
                  disabled={isConfirmDisabled() || userLoading}
                  onClick={confirmEdit}
                >
                  {loadingWrapper(userLoading, <>Conferma</>)}
                </Button>
              </>
            )}
          </fieldset>}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditUser;
